import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 3.5H11V13.5H3V3.5ZM21 3.5H13V9.5H21V3.5ZM9 11.5V5.5H5V11.5H9ZM19 7.5V5.5H15V7.5H19ZM19 13.5V19.5H15V13.5H19ZM9 19.5V17.5H5V19.5H9ZM21 11.5H13V21.5H21V11.5ZM3 15.5H11V21.5H3V15.5Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 3,
			y: 3,
			width: 18,
			height: 19,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3 3.5H11V13.5H3V3.5ZM21 3.5H13V9.5H21V3.5ZM9 11.5V5.5H5V11.5H9ZM19 7.5V5.5H15V7.5H19ZM19 13.5V19.5H15V13.5H19ZM9 19.5V17.5H5V19.5H9ZM21 11.5H13V21.5H21V11.5ZM3 15.5H11V21.5H3V15.5Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
